/* global axios */

import ApiClient from '../ApiClient';

class FollowUpCadencesAPI extends ApiClient {
    constructor() {
        super('follow_up_cadences', { accountScoped: true });
    }

    get url() {
        return `${this.baseUrl()}/crm/follow_up_cadences`;
    }

    getAll() {
        return axios.get(this.url);
    }

    show(id) {
        return axios.get(`${this.url}/${id}`);
    }

    create(data) {
        return axios.post(this.url, { cadence: data });
    }

    update(id, data) {
        return axios.patch(`${this.url}/${id}`, { cadence: data });
    }

    delete(id) {
        return axios.delete(`${this.url}/${id}`);
    }

    enrollDeal(cadenceId, dealId) {
        return axios.post(`${this.url}/${cadenceId}/enroll_deal`, { deal_id: dealId });
    }

    unenrollDeal(cadenceId, dealId) {
        return axios.post(`${this.url}/${cadenceId}/unenroll_deal`, { deal_id: dealId });
    }

    getWhatsappTemplates(inboxId) {
        return axios.get(`${this.url}/whatsapp_templates`, {
            params: { inbox_id: inboxId },
        });
    }

    getReport() {
        return axios.get(`${this.url}/report`);
    }
}

export default new FollowUpCadencesAPI();
